var map = {
	"./elon.jpg": "d21f",
	"./jolil.jpg": "d6e0",
	"./kajalshanto.jpg": "b07d",
	"./ranbeer.jpg": "5260",
	"./raselevaly.jpg": "786c",
	"./sakib.jpg": "eb4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";